import { Helmet } from 'react-helmet-async';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategoryNav from './components/CategoryNav';
import LatestUpdate from './components/LatestUpdate';
import RankingSection from './components/RankingSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '韩漫大全',
    url: 'https://hanmandq.com',
    description: '韩漫漫画网站，汇聚众多好看韩国漫画，支持韩漫在线免费阅读，大全内容涵盖各种热门合集，满足您的多元化口味。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://hanmandq.com/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '韩漫大全',
    url: 'https://hanmandq.com',
    logo: 'https://hanmandq.com/logo.png',
    description: '韩漫漫画网站 - 好看韩国漫画在线免费阅读平台',
  };

  const faqSchema = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: [
      {
        '@type': 'Question',
        name: '韩漫大全是什么网站？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫大全是一个专注于韩国漫画在线免费阅读的中文平台，汇集了众多好看韩国漫画，涵盖恋爱、奇幻、动作、搞笑、悬疑等多种分类的热门合集。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫在线免费阅读是否需要注册？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫大全上的所有韩国漫画均可免费在线阅读，无需注册和登录，打开网站即可畅享阅读体验。',
        },
      },
      {
        '@type': 'Question',
        name: '韩漫大全有哪些分类？',
        acceptedAnswer: {
          '@type': 'Answer',
          text: '韩漫大全涵盖恋爱、奇幻、动作、搞笑、剧情、悬疑、日常等多种分类，每种分类下有丰富的韩国漫画作品，满足不同读者的多元化口味。',
        },
      },
    ],
  };

  return (
    <>
      <Helmet>
        <title>韩漫漫画网站-好看的韩国漫画_韩漫在线免费阅读_韩漫大全</title>
        <meta name="description" content="韩漫漫画网站汇聚了众多好看韩国漫画，支持韩漫在线免费阅读，大全内容涵盖各种热门合集，满足您的多元化口味。韩漫大全提供高品质韩国漫画在线阅读体验。" />
        <meta name="keywords" content="韩漫漫画网站,好看韩国漫画,韩漫在线免费阅读,韩漫大全,热门合集" />
        <link rel="canonical" href="https://hanmandq.com/" />
        <meta property="og:title" content="韩漫漫画网站-好看的韩国漫画_韩漫在线免费阅读_韩漫大全" />
        <meta property="og:description" content="韩漫漫画网站汇聚了众多好看韩国漫画，支持韩漫在线免费阅读，大全内容涵盖各种热门合集，满足您的多元化口味。" />
        <meta property="og:url" content="https://hanmandq.com/" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="韩漫漫画网站-好看的韩国漫画_韩漫在线免费阅读_韩漫大全" />
        <meta name="twitter:description" content="韩漫漫画网站汇聚了众多好看韩国漫画，支持韩漫在线免费阅读，大全内容涵盖各种热门合集，满足您的多元化口味。" />
      </Helmet>

      <script type="application/ld+json">{JSON.stringify(websiteSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationSchema)}</script>
      <script type="application/ld+json">{JSON.stringify(faqSchema)}</script>

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main>
          <HeroSection />
          <HotRecommend />
          <CategoryNav />
          <LatestUpdate />
          <RankingSection />
        </main>
        <Footer />
      </div>
    </>
  );
}